import { css, jsx } from '@emotion/core';
import { Checkbox } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleFormChange } from '@/src/register/redux/registerAccountReducer';

import Label from './Label';

const styles = {
  checkboxInfoContainer: css`
    max-width: 36.5rem;
    width: 100%;
    margin: 1.6rem 0;
  `,
  checkboxLabelText: css`
    font-size: 1.2rem;
    font-weight: 900;
    margin-left: 8px;
  `,
};

const InformalNameCheckbox = props => {
  const { form, info } = props;
  const dispatch = useDispatch();

  const { register } = useSelector(state => state);
  const { First, isInformalNameSameAsName } = register;

  const onChange = e => {
    const {
      target: { checked },
    } = e;

    if (checked) {
      if (First !== '') {
        form.setFieldsValue({
          Informal: First,
        });
      } else {
        form.setFieldsValue({
          Informal: '',
        });
      }
      dispatch(handleFormChange({ name: 'isInformalNameSameAsName', value: true }));
    } else {
      dispatch(handleFormChange({ name: 'isInformalNameSameAsName', value: false }));
    }
  };

  const { checkboxLabel } = info;
  return (
    <div css={styles.checkboxInfoContainer}>
      <Label info={info} />
      <div>
        <Checkbox
          defaultChecked={true}
          onChange={e => onChange(e)}
          checked={isInformalNameSameAsName}
        />
        <span css={styles.checkboxLabelText}>{checkboxLabel}</span>
      </div>
    </div>
  );
};

export default InformalNameCheckbox;
